import { useSourcingExternalStore } from 'modules/sourcing-external/stores';
import { useShallow } from 'zustand/react/shallow';
import { SourcingSharedChooseChannelStep } from 'modules/sourcing-shared/shared-steps';
import { getSourcingExternalHeaderBreadcrumbs } from 'modules/sourcing-external/utils/getSourcingExternalHeaderBreadcrumbs';

export const SourcingExternalChooseChannelStep = () => {
  const {
    candidateBatch,
    channelFormData,
    onChooseChannelBack,
    onChooseChannelNext,
    setStep
  } = useSourcingExternalStore(
    useShallow((state) => ({
      candidateBatch: state.candidateBatch,
      channelFormData: state.channelFormData,
      onChooseChannelBack: state.onChooseChannelBack,
      onChooseChannelNext: state.onChooseChannelNext,
      setStep: state.setStep
    }))
  );

  return (
    <SourcingSharedChooseChannelStep
      headerBreadcrumbs={getSourcingExternalHeaderBreadcrumbs({
        candidateBatchJobTitle:
          candidateBatch?.jobDescriptionParsed?.jobTitle ?? '',
        candidateBatchId: candidateBatch?.id ?? '',
        setStep
      })}
      defaultFormData={channelFormData}
      onChooseChannelNext={onChooseChannelNext}
      onHeaderBack={onChooseChannelBack}
    />
  );
};
